module.exports = {
  SERVER: 'https://test-api.thegiftguide.com/api',
  APPLINK: 'https://test.thegiftguide.com'
};
